if (!Array.prototype.hasOwnProperty('flat')) {

    /**
     * Flattens an array.
     *
     * @param {any} args - Array to flatte
     * @returns {Array} - Flattened array
     */
    const flatten = (args) => args.reduce(
        (accumulator, currentVal) => accumulator.concat(
            Array.isArray(currentVal) ? flatten(currentVal) : currentVal
        ), []
    );
    Object.defineProperty(Array.prototype, 'flat', {
        value: function() {
            return flatten(this);
        }
    });
}
